export enum GlcValueEnum {
  YES = 'YES',
  NO = 'NO',
}
